import { type SearchSourceId } from "@/features/map/utils/buildSearchChain";

/**
 * データソースの表示名。ポップアップの出典バッジや範囲検索結果の出典列に出す。
 *
 * レイヤーパネルのラベルと揃えつつ、GEOSPACE と役所で同じ「地番地図」になって
 * 区別できなくなるのを避けるため、ここでは系統名を含んだ名前にする。
 */
export const SEARCH_SOURCE_LABEL: Record<SearchSourceId, string> = {
  geospaceChiban: "GEOSPACE 地番地図",
  geospaceLegalAffairs: "法務省地番地図",
  trustartChiban: "役所地番地図",
  registrationMap: "登記所備付地図",
  // ゼンリンの地番データはブルーマップに由来するため、レイヤー名と揃える
  zenrin: "ブルーマップ",
};

/**
 * 範囲検索で一度に取得できる件数の上限。結果一覧に上限の説明を出す。
 *
 * GEOSPACE 系は 50 件、役所系 2 ソースは BE が 1000 件で打ち切る。ブルーマップには無い。
 * 打ち切ったことを BE が返すのは登記所備付地図だけで、そのときは結果一覧で別途知らせる。
 */
export const RANGE_SEARCH_RESULT_LIMIT: Partial<
  Record<SearchSourceId, number>
> = {
  geospaceChiban: 50,
  geospaceLegalAffairs: 50,
  trustartChiban: 1000,
  registrationMap: 1000,
};

/**
 * どの地番データソースにも当たらず、座標のみを Google のジオコーディングで得たときの出典名。
 *
 * FE の whenSearchFail が得た座標と、役所系ソースが筆ミス時に返した座標（BE が同じ
 * Google Geocoding API で得たもの）の両方に使う。地番を伴わない結果であることを
 * 利用者に示すため、ラベル自体に明記する。
 */
export const GOOGLE_GEOCODE_SOURCE_LABEL = "Google（地番なし）";
